import { __assign } from "tslib";
import React from 'react';
import { hydrateRoot } from 'react-dom/client';
export var asReactApp = function (Component) {
    var props = window[Component.storeId];
    var domNode = document.getElementById(Component.hydrateId);
    hydrateRoot(domNode, React.createElement(Component, __assign({}, props)));
};
export default asReactApp;
//# sourceMappingURL=as-react-app.js.map